module.exports = __webpack_public_path__ + "img/portfolio.bb06bee3.webp";